<template>
  ({{ nbHits }})
</template>

<script setup>
const props = defineProps({
  nbHits: {
    type: Number,
    default: null
  },
  nbPages: {
    type: Number,
    default: null
  },
  currentPage: {
    type: Number,
    default: null
  }
})

const { $track } = useNuxtApp()

onMounted(async () => {
  await $track.filter.resultsLoaded({
    totalResults: props.nbHits,
    totalPages: props.nbPages,
    pageNumber: props.currentPage
  })
})
</script>